import { lazy, ComponentType } from 'react'

const RELOAD_KEY = 'lazy-retry-reloaded'

// Wraps React.lazy so a failed chunk load (common after a new deploy has
// invalidated the hashed filenames the cached index.html points at) triggers
// one hard reload to pick up the fresh asset manifest. A sessionStorage flag
// prevents infinite reload loops if the chunk is genuinely broken.
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- ComponentType<any> is the canonical React generic constraint for lazy
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      const mod = await factory()
      sessionStorage.removeItem(RELOAD_KEY)
      return mod
    } catch (err) {
      const alreadyReloaded = sessionStorage.getItem(RELOAD_KEY) === '1'
      const msg = err instanceof Error ? err.message : String(err)
      const isChunkError = /Failed to fetch dynamically imported module|Loading chunk|Importing a module script failed/i.test(msg)
      if (isChunkError && !alreadyReloaded) {
        sessionStorage.setItem(RELOAD_KEY, '1')
        window.location.reload()
        return new Promise<never>(() => {})
      }
      throw err
    }
  })
}
